import cn from "../../lib/classnames";
import React from "react";
import styles from "./ValidationList.module.css";
import textStyles from "../../styles/Text.module.css";

type Props = {
    messages: string[];
    className?: string;
};

export default function ValidationList({messages, className}: Props) {
    if (!messages.length) {
        return null;
    }

    return (
        <>
            {messages.map((msg, i) => {
                const isLast = i === messages.length - 1;
                return (
                    <div
                        className={cn(
                            textStyles.inputError,
                            styles.validation,
                            isLast ? styles.lastValidation : undefined,
                            className,
                        )}
                        key={i}
                    >
                        {msg}
                    </div>
                );
            })}
        </>
    );
}
